const cities = ['sydney', 'melbourne'];

export default cities;
